<div class="hx-textarea-wrapper">
  <textarea
    #textareaElement
    class="hx-textarea"
    [attr.aria-disabled]="disabledState() || null"
    [attr.aria-invalid]="errorState"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-labelledby]="ariaLabelledby() || null"
    [attr.aria-readonly]="readonly()"
    [attr.aria-required]="requiredValue"
    [attr.disabled]="disabledState() ? '' : null"
    [attr.id]="idValue"
    [attr.placeholder]="placeholderValue"
    [attr.readonly]="readonly() ? '' : null"
    [attr.required]="requiredValue ? '' : null"
    [attr.rows]="rows()"
    [attr.cols]="cols()"
    [attr.maxlength]="maxlength() ?? null"
    [class.hx-textarea--with-dictation]="showDictation()"
    [class.hx-textarea-autofilled]="autofilled"
    [class.hx-textarea-disabled]="disabledState()"
    [class.hx-textarea-error]="errorState"
    [class.hx-textarea-focused]="focused"
    [class.hx-textarea-lg]="size() === 'lg'"
    [class.hx-textarea-outline]="variant() === 'outline'"
    [class.hx-textarea-sm]="size() === 'sm'"
    [class.hx-textarea-xl]="size() === 'xl'"
    (blur)="_onBlur()"
    (focus)="_onFocus()"
    (input)="_onInput()"></textarea>
  @if (showDictation()) {
    <button
      hxIconButton
      type="button"
      variant="ghost"
      context="neutral"
      size="xs"
      class="hx-textarea__dictation-button"
      [class.hx-textarea__dictation-button--listening]="dictationState() === 'listening'"
      [class.hx-textarea__dictation-button--error]="dictationState() === 'error'"
      [svgIcon]="dictationState() === 'listening' ? 'ccs-mic-fill' : 'ccs-mic'"
      [disabled]="disabledState() || readonly()"
      [attr.aria-pressed]="dictationState() === 'listening'"
      [attr.aria-label]="dictationButtonLabel()"
      [attr.title]="dictationButtonLabel()"
      (pointerenter)="_onDictationButtonWarmUp()"
      (focus)="_onDictationButtonWarmUp()"
      (click)="_onDictationButtonClick($event)"></button>
  }
</div>
